//import Link from "next/link";
import { FunctionComponent } from "react";
import { Col, ColLeft, ColRight } from "../components/Col";
import Button from "../components/Button";

// import footer images
import Logo from "../assets/svg/logo.svg";
import AuLogo from "../assets/img/australian-gov@1x.png";
import AuLogox2 from "../assets/img/australian-gov@2x.png";
import AuLogox3 from "../assets/img/australian-gov@3x.png";
import moment from "moment";

const Footer: FunctionComponent = () => {
  const currentYear = moment().format("YYYY");

  return (
    <footer role="footer" className="footer">
      <div className="footer__inner">
        <Col class="col-flex--strecth">
          <ColLeft class="footer__inner-left">
            <div className="footer__inner-logos">
              <div className="footer__inner-logo">
                <a href="https://www.sea.museum">
                  <Logo alt="Sea Museum" />
                </a>
              </div>
              <div className="footer__inner-au">
                <img src={AuLogo} alt="Australian Government" srcSet={`${AuLogox2} 2x, ${AuLogox3} 3x`} />
              </div>
            </div>
            <div className="footer__inner-address">
              <div>
                2 Murray Street, Darling Harbour
                <br />
                Sydney NSW 2000,
                <br />
                Australia
              </div>
              <div>
                <a className="white-link" href="tel:+61292983777">
                  +61 2 9298 3777
                </a>
                <br />
                <a className="white-link" href="mailto:tickets@sea.museum">
                  tickets@sea.museum
                </a>
              </div>
            </div>
          </ColLeft>
          <ColRight class="footer__inner-right">
            <div>
              <Button
                btnHref="https://www.sea.museum"
                linkType="exlink"
                btnClass="white,large"
                ariaLabel="Go back to home page"
              >
                Home
              </Button>
            </div>
            <div>&copy; {currentYear} ANMM</div>
          </ColRight>
        </Col>
      </div>
    </footer>
  );
};

export default Footer;
